export const TICKET_EVENT_TYPE = {
  MESSAGE: 1,
  IMAGE: 2,
  PART: 3,
  PART_NEEDED: 4,
  OPEN: 5,
  CLOSED: 6,
  ASSIGNED: 7,
  UNASSIGN: 8,
  ONSITE: 9,
  ALERTED: 10,
  WARRANTY: 11,
  NOTE: 12,
};

export const CRANE_EVENT_TYPE = {
  MESSAGE: 1,
  IMAGE: 2,
  TICKET_OPENED: 3,
  TICKET_CLOSED: 4,
};

export const PROSPECT_EVENT_TYPE = {
  MESSAGE: 1,
  IMAGE: 2,
};

export const isImageTypeId = (typeId) => Number(typeId) === 2;
export const isPartTypeId = (typeId) => {
  const id = Number(typeId);
  return id === TICKET_EVENT_TYPE.PART || id === TICKET_EVENT_TYPE.PART_NEEDED;
};
